import { runInAction, makeAutoObservable, action } from 'mobx';
import { Profile, UserProfileEntryProps, WatcherrError } from '@ixicare/resources';

import { State } from '~/store/types';
import UserProfile from '../Profile/UserProfileEntry';

class HealthcareProviderDetailStore {
  rootStore: State;
  profile?: UserProfile;
  error?: WatcherrError;
  loading: boolean = false;

  constructor(rootStore: State) {
    makeAutoObservable(this, {
      loadHealthcareProvider: action.bound,
      rootStore: false,
    });
    this.rootStore = rootStore;
  }

  loadHealthcareProvider(id) {
    this.loading = true;

    Profile.getProfile(id)
      .then((profile) => {
        runInAction(() => {
          this.setProfile(profile);
          this.loading = false;
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.loading = false;
          this.error = err;
        });
      });
  }

  private setProfile(profile: UserProfileEntryProps) {
    this.profile = new UserProfile(this.rootStore, profile);
  }
}

export default HealthcareProviderDetailStore;
